/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiResponseModel, CommonResponseModel } from '../types/common'
import {
  DeleteRuleManagementRequestModel,
  InsertRuleManagementRequestModel,
  RuleManagemenDetailModel,
  UpdateRuleManagementRequestModel,
} from '../types/rule-managements'
import axios from './axios'

const rulemanagementApis = {
  gets: () =>
    axios.get<any, ApiResponseModel<Array<RuleManagemenDetailModel>>>(
      '/getrulemanagement'
    ),
  get: (id: string) =>
    axios.get<any, ApiResponseModel<Array<RuleManagemenDetailModel>>>(
      `/rulemanagementdetail/`,
      { params: { ruleId: id } }
    ),
  insert: (payload: InsertRuleManagementRequestModel) =>
    axios.post<any, ApiResponseModel<CommonResponseModel>>(
      '/insertrulemanagement',
      payload
    ),
  update: (payload: UpdateRuleManagementRequestModel) =>
    axios.post<any, ApiResponseModel<CommonResponseModel>>(
      '/updaterulemanagement',
      payload
    ),
  delete: (payload: DeleteRuleManagementRequestModel) =>
    axios.post<any, ApiResponseModel<CommonResponseModel>>(
      '/deleterulemanagement',
      payload
    ),
}

export default rulemanagementApis
